<template>
  <div class="detailbg">
    <!-- <img src="../static/articleheader.jpg" class="articleheader" alt=""> -->
    <div class="title">
      {{ title }}
    </div>
    <div class="time">
      {{ publish_time }}
    </div>
    <div class="content" >
      <div v-html="content" >

      </div>

      <img src="../static/bottom-back.jpg" class="details-back" @click="close" alt="">
    </div>
  </div>
</template>

<script >
import { getRequest } from '../untils/api'
import { md5 } from '../untils/md5'
export default {
data() {
  return {
    title:'',
    publish_time:'',
    content:'',
    
  }
},
props: {
    id: {
      type: Number,
      default: ''
    }
  },
methods: {
  replacrImg(detailText) {
                detailText = detailText.replace(/<img[^>]*>/gi, function(match, capture) {
                    return match.replace(/(style="(.*?)")|(width="(.*?)")|(height="(.*?)")/ig,
                        'style="max-width:100%;height:auto;"') // 替换style
                });
                return detailText;
            },
  detail() {
      
            let number = Math.floor(Math.random() * 999);
            // console.log(number)
            const time = Math.round(new Date().getTime() / 1000);
            // console.log(time)
            let id =1702948
            let MD5 = md5("id=" + this.id + '&noncestr=' + number + '&timestamp=' + time + 'PBSq5ADJAyBPFa72', 32)
            // console.log(MD5)
            getRequest('/detail?id=' + this.id + '&noncestr=' + number + '&timestamp=' + time + '&sign=' + MD5).then(res => {
                console.log(res.data)
                this.title=res.data.data.title
                this.publish_time=res.data.data.publish_time
                this.content=res.data.data.content.replace(/<img/g,"<img style='max-width:100%;height:auto;'");
                this.content=this.content.replace(/<video/g,"<video style='width:100%;height:auto;'");
                this.content=this.content.replace(/width: 688.551px;/g,"");
                this.content=this.content.replace(/width: 688px;/g,"");
                this.content=this.content.replace(/<p style="text-indent: 2em; writing-mode: horizontal-tb; text-orientation: mixed; line-height: 1.75em;">/g,'<p style="text-indent: 2em; writing-mode: horizontal-tb; text-orientation: mixed;">')
                this.content=this.content.replace(/<p style="text-align: justify; text-indent: 2em; writing-mode: horizontal-tb; text-orientation: mixed; line-height: 1.75em;">/g,'<p style="text-align: justify; text-indent: 2em; writing-mode: horizontal-tb; text-orientation: mixed;">')  
            })
        },
        close(){
          this.$emit('child-event');
        }
},
mounted() {
  this.detail()
},
}
</script>

<style lang="less" >
.detailbg{
   overflow: hidden;
   width: 100%;
    // overflow-y: scroll;
    .articleheader{
      
        display: block;
        width: 100%;
    }
    .title{
      font-weight: 800;
      margin-top: 30px;
      font-size: 22px;
      padding: 0px 10px;
      text-align: center;
    }
    .time{
      font-size: 16px;
      color: #b1b1b1;
      margin-top: 10px;
      padding-bottom: 20px;
      border-bottom: #f1f1f1 2px solid;
      text-align: center;
    }
     .content{
      position: relative;
       width: 100%;
       padding: 10px;
       box-sizing: border-box;
       margin-bottom: 50px;
      p{
       font-size: 16px;
      }
       /deep/ img{
        max-width: 100% !important;
    }
    .details-back{
      position: fixed;
      left: 50%;
      bottom: 0px;
      width: 375px;
      margin-left: -187px;
    
    }
    }
   
}
</style>
